<episode-panel></episode-panel>
<smiley-rating
  *ngIf="watchedEpisode && feedbackRequired"
  [episodeId]="(_episodeId$ | async)"
  [existingRating]="(_currentEpisodeUser$ | async)?.rating ?? null"
  (ratingSubmitted)="onRatingSubmitted($event)">
</smiley-rating>
<episode-description></episode-description>
<site-footer color="#1EA282"></site-footer>
